import $ from 'jquery';
$("a.edit-view-details").click(function(){
    $(".cwm-account-form, .my-account_Wrapper").show();
    $("a.edit-view-details, #form-successful-messgae").hide();
   
    $('html,body').animate({
        scrollTop: $(".cwm-account-form").offset().top - 220},
        '2000');
  });



// WEBPACK FOOTER //
// ./components/cwm-custom-scripts/cwm-edit-account-details.js